import React from 'react';
import { Card } from './ui/Card';
import { Button } from './ui/Button';
import { Link } from 'react-router-dom';
import { ArrowRight, BoxIcon } from 'lucide-react';
interface ServiceCardProps {
  title: string;
  description: string;
  icon: BoxIcon;
  features: string[];
  link: string;
}
export function ServiceCard({
  title,
  description,
  icon: Icon,
  features,
  link
}: ServiceCardProps) {
  return <Card className="flex flex-col h-full hover:shadow-md transition-shadow duration-300" data-id="element-132">
      <div className="p-6 flex-1" data-id="element-133">
        <div className="h-12 w-12 bg-purple-50 rounded-lg flex items-center justify-center mb-6" data-id="element-134">
          <Icon className="h-6 w-6 text-[#7B2FE0]" data-id="element-135" />
        </div>
        <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-136">{title}</h3>
        <p className="text-slate-600 mb-6 leading-relaxed" data-id="element-137">{description}</p>
        <ul className="space-y-2 mb-6" data-id="element-138">
          {features.map((feature, idx) => <li key={idx} className="flex items-start text-sm text-slate-600" data-id="element-139">
              <span className="mr-2 text-[#7B2FE0]" data-id="element-140">•</span>
              {feature}
            </li>)}
        </ul>
      </div>
      <div className="p-6 pt-0 mt-auto" data-id="element-141">
        <Link to={link} data-id="element-142">
          <Button variant="outline" className="w-full group" data-id="element-143">
            Learn More
            <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" data-id="element-144" />
          </Button>
        </Link>
      </div>
    </Card>;
}